import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Select,
  MenuItem,
  Grid,
  Stack,
} from '@mui/material';
import { Close, InsertDriveFile as FileIcon } from '@mui/icons-material';
import styles from './composeMail.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { SEND_MAIL } from '_redux/types/mail.types';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { authActions } from '_redux/slices/auth.slice';

const ComposeMailMultiple = ({ onClose, file }) => {
  const dispatch = useDispatch();
  const { user } = useSelector(authActions.selectors.getUser);
  const [attachment, setAttachment] = useState(file);

  // Available recipient emails
  const availableEmails = ['admin@gmail.com'];

  const validationSchema = Yup.object({
    to: Yup.string()
      .email('Invalid email address')
      .required('Recipient email is required'),
    subject: Yup.string().required('Subject is required'),
    content: Yup.string().required('Email content is required'),
  });

  const initialValues = {
    to: 'admin@gmail.com', // Default selected email
    subject: '',
    content: '',
  };

  const handleSubmit = (values, { resetForm }) => {
    const formData = new FormData();

    formData.append('receipentName', values.to.split('@')[0]);
    formData.append('senderName', `${user.firstName} ${user?.lastName}`);
    formData.append('senderEmail', user.email);
    formData.append('receipentEmail', values.to);
    formData.append('subject', values.subject);
    formData.append('heading', values.subject);
    formData.append('description', values.content);
    formData.append('footer', 'Looking forward to hearing from you');

    if (attachment) {
      formData.append('files', attachment);
    }

    dispatch({ type: SEND_MAIL, payload: formData });
    resetForm();
    setAttachment(null);
    onClose();
  };

  return (
    <Box className={styles.composeMailContainer}>
      <Box className={styles.header}>
        <Typography variant="h6" className={styles.title}>
          Compose Email
        </Typography>
        <IconButton onClick={onClose} className={styles.closeButton}>
          <Close />
        </IconButton>
      </Box>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleBlur,
          values,
          setFieldValue,
        }) => (
          <Form>
            <Box className={styles.body}>
              <TextField
                fullWidth
                variant="outlined"
                label="From"
                value={user.email}
                className={styles.inputField}
                // disabled
              />

              <Select
                fullWidth
                variant="outlined"
                // label="To"
                name="to"
                value={values.to}
                onChange={event => setFieldValue('to', event.target.value)}
                className={styles.inputField}
                error={touched.to && !!errors.to}
              >
                {availableEmails.map(email => (
                  <MenuItem key={email} value={email}>
                    {email}
                  </MenuItem>
                ))}
              </Select>
              {touched.to && errors.to && (
                <Typography className={styles.errorText}>
                  {errors.to}
                </Typography>
              )}

              <TextField
                fullWidth
                variant="outlined"
                label="Subject"
                name="subject"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.subject}
                error={touched.subject && !!errors.subject}
                helperText={touched.subject && errors.subject}
              />

              <TextField
                fullWidth
                variant="outlined"
                label="Content"
                name="content"
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.content}
                multiline
                rows={3}
                error={touched.content && !!errors.content}
                helperText={touched.content && errors.content}
              />
              <Grid container xs={12} spacing={2} width="100%">
                {!!attachment?.length &&
                  attachment?.map((attach, index) => (
                    <Grid item key={index} xs={12} md={6}>
                      <Stack
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                        border={1}
                        borderColor="divider"
                        borderRadius={1}
                        padding={1}
                        // sx={{ cursor: 'pointer' }}
                      >
                        <FileIcon />
                        <Typography className={styles.fileName}>
                          {attach?.name}
                        </Typography>
                      </Stack>
                    </Grid>
                  ))}
              </Grid>
            </Box>

            <Box className={styles.footer2}>
              <Button
                type="submit"
                variant="contained"
                className={styles.submitButton}
              >
                Submit
              </Button>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default ComposeMailMultiple;
